var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGrayCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "351 0 17 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M353.5 8.496c0 4.618 4.999 7.507 9 5.196 1.855-1.07 3-3.05 3-5.196 0-4.618-4.999-7.503-9-5.196a6.006 6.006 0 0 0-3 5.196Z",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 3,
  stroke: "rgba(111,111,111,0.4 )",
  fill: "transparent",
  "data-name": "Path 280381"
})));
export default SvgGrayCircle;